import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import {
  ViewModule as StackerViewIcon,
  FormatListBulleted as ListViewIcon,
  LocalGasStationOutlined as GasoilIcon,
} from "@mui/icons-material";

const PLANNER_STACKER_ROUTE = "/container-planner";
const PLANNER_LIST_ROUTE = "/voyages/manage";
const PLANNER_GASOIL_ROUTE = "/vessel/gasoil";

export type PlannerViewMode = "stacker" | "list" | "gasoil";

type PlannerViewSwitchProps = {
  activeView: PlannerViewMode;
  disabled?: boolean;
  t: any;
};

const PlannerViewSwitch = ({
  activeView,
  disabled = false,
  t,
}: PlannerViewSwitchProps) => {
  const handleViewChange = (
    event: React.MouseEvent<HTMLElement>,
    nextView: PlannerViewMode | null
  ) => {
    if (!nextView || nextView === activeView || disabled) {
      return;
    }

    if (nextView === "stacker") {
      window.location.href = PLANNER_STACKER_ROUTE;
      return;
    }

    if (nextView === "list") {
      window.location.href = PLANNER_LIST_ROUTE;
      return;
    }

    window.location.href = PLANNER_GASOIL_ROUTE;
  };

  return (
    <ToggleButtonGroup
      value={activeView}
      exclusive
      onChange={handleViewChange}
      disabled={disabled}
      sx={{
        height: 40,
        p: 0.35,
        borderRadius: "10px",
        backgroundColor: "#ffffff",
        border: "1px solid rgba(15, 23, 42, 0.12)",
        overflow: "hidden",
        "& .MuiToggleButtonGroup-grouped": {
          m: 0,
          border: "0 !important",
          borderRadius: "8px !important",
          px: 1.25,
          minWidth: 96,
          height: 32,
          gap: 0.75,
          fontSize: "0.68rem",
          fontWeight: 900,
          color: "text.primary",
          textTransform: "uppercase",
          whiteSpace: "nowrap",
          transition:
            "background-color 120ms ease, color 120ms ease, border-color 120ms ease",
          "&.Mui-selected": {
            color: "#ffffff",
            backgroundColor: "#2563eb",
            "&:hover": {
              backgroundColor: "#1d4ed8",
            },
          },
          "&:hover": {
            backgroundColor: "rgba(37, 99, 235, 0.06)",
          },
          "&.Mui-disabled": {
            opacity: 0.55,
          },
        },
      }}
    >
      <ToggleButton value="stacker" aria-label={t("stackerView")}>
        <StackerViewIcon sx={{ fontSize: 16 }} />
        {t("stackerView", "Stacker")}
      </ToggleButton>

      <ToggleButton value="list" aria-label={t("listView")}>
        <ListViewIcon sx={{ fontSize: 17 }} />
        {t("listView", "List")}
      </ToggleButton>

      <ToggleButton value="gasoil" aria-label={t("gasoil", "Gasoil")}>
        <GasoilIcon sx={{ fontSize: 17 }} />
        {t("gasoil", "Gasoil")}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default PlannerViewSwitch;